var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('add-or-edit-calc-modal',{attrs:{"modal_title":_vm.isEdit ? 'Редактироваеие' : 'Добавить',"modal-id":"calc-modal-add-edit","form_fields":_vm.getFields,"def_form_obj":_vm.form_obj},on:{"formSubmit":_vm.saveClick}})}
var staticRenderFns = []

export { render, staticRenderFns }